import React, { SetStateAction, useContext, useEffect, useState } from "react";
import { Col, Button, Row, Accordion, Spinner, useAccordionToggle } from "react-bootstrap";
import GuestInfo from "./guest-info/GuestInfo";
import CancelledGuest from "./guest-info/CancelledGuest";
import MobileGuestInfo from "./guest-info/mobile-guest-info/MobileGuestInfo";
import MobileCancelledGuest from "./guest-info/mobile-canceled-guest/MobileCanceledGuest";
import StartWidget from "../../../../../../Data/StartWidget";
import Itinerary from "../../../../../../Data/Itinerary";
import { WidgetContext } from "../../../../../../context/WidgetContext";
import Quote from "../../../../../../Data/Quote/Quote";
import ReservationGuest from "../../../../../../Data/Reservation/ReservationGuest";
import { ReservationCustomer } from "../../../../../../Data/Reservation/ReservationCustomer";
import useUpdateReservationCustomers from "../../data-service-hooks/UseUpdateReservationCustomers";
import Reservation from "../../../../../../Data/Reservation/Reservation";
import Decimal from "decimal.js";
import { PaymentAllocationCategory } from "../../../../../../Data/Reservation/PaymentAllocationCategory";
import useFetch, { FetchRequest } from "../../../../../../_helpers/UseFetchHook";
import { toast } from "react-toastify";
import { Constants } from "../../../../../../_helpers/Constants";
import useCreateIndividualCategory, { CreateIndividualCategoryRequest } from "../../data-service-hooks/UseCreateIndividualCategory";
import ViewPort from "../../../../../../_helpers/Enums/ViewPortEnum";

interface props {
  quote: Quote;
  setShowModal: React.Dispatch<SetStateAction<string>>;
  onReservationCustomerAdded: (reservationCustomer: ReservationCustomer) => void;
  onPayClicked: (customer: ReservationCustomer) => void;
  emailCustomer: ReservationCustomer | undefined;
  handleUseIndividualPayments: (quote: Quote) => void;
  isQuoteExpired: boolean;
  allowPromo: boolean;
}

const Total: React.FC<props> = (props) => {
  const { startWidget, style, fromEmail, viewPortBreakPoint, brand, companyId } = useContext(WidgetContext);
  const { setShowModal, onReservationCustomerAdded, onPayClicked, emailCustomer } = props;
  const [quote, setQuote] = useState<Quote>(props.quote);

  const itinerary = {
    lodgingItineraries: quote.reservation.lodgingItineraries,
    golfItineraries: quote.reservation.golfItineraries,
    transportItineraries: quote.reservation.transportItineraries,
    customItineraries: quote.reservation.customItineraries,
    adjustments: quote.reservation.adjustments
  }

  const [collapsed, setCollapsed] = useState(false);
  const [reservationCustomers, setReservationCustomers] = useState<ReservationCustomer[]>(
    quote.reservation.reservationCustomers ? quote.reservation.reservationCustomers : []
  );
  const [reservationGuests, setReservationGuests] = useState<ReservationGuest[]>([]);
  // const hasAllocations = quote.reservation.reservationCustomers.some(rc => rc.paymentAllocationCategory != null);

  const paymentAllocations: PaymentAllocationCategory[] = quote.reservation.paymentCategories ? quote.reservation.paymentCategories : [];
  const hasAllocations = paymentAllocations.length > 0;

  const balanceDue = new Decimal(quote.reservation.balanceDue ? quote.reservation.balanceDue : 0.0).toDecimalPlaces(2).toNumber();
  const totalSell = new Decimal(quote.reservation.totalSell ? quote.reservation.totalSell : 0.0).toDecimalPlaces(2).toNumber();
  const tax = new Decimal(quote.reservation.tax ? quote.reservation.tax : 0.0).toDecimalPlaces(2).toNumber();
  const resortFees = new Decimal(quote.reservation.resortFees ? quote.reservation.resortFees : 0.0).toDecimalPlaces(2).toNumber();
  const cleaningFees = new Decimal(quote.reservation.cleaningFee ? quote.reservation.cleaningFee : 0.0).toDecimalPlaces(2).toNumber();
  const discountsApplied = new Decimal(quote.reservation.discountApplied ? quote.reservation.discountApplied : 0.0).toDecimalPlaces(2).toNumber();
  // const grandTotal = ((totalSell * 100) + (tax * 100) + (resortFees * 100) + (cleaningFees * 100)) / 100;
  const promoCodeName = quote.reservation.promo ? quote.reservation.promo.promoCodeName : undefined;

  const evenCategory = paymentAllocations.find(a => a.categoryName === "Even Split");
  const allocatedCustomers = quote.reservation.reservationCustomers.filter(r => !!r.paymentAllocationCategory);
  // const customersCountWithEvenSplit = allocatedCustomers.filter(c => c.paymentAllocationCategory === evenCategory).length;
  const evenPersonsToDivideBy = quote.reservation.numGuests - PaymentAllocationCategory.getTotalAllocationLines(paymentAllocations);

  const priceMinusCategories = new Decimal(totalSell - PaymentAllocationCategory.getTotalAllocationsCost(paymentAllocations, itinerary, props.quote.reservation.numGuests - props.quote.reservation.reservationCustomers.filter(c => c.cancelled).length)).toDecimalPlaces(2).toNumber();
  const evenPerPersonPrice = new Decimal(priceMinusCategories).dividedBy(evenPersonsToDivideBy === 0 ? 1 : evenPersonsToDivideBy).toDecimalPlaces(2).toNumber();
  const resPerPersonPrice = new Decimal(totalSell).dividedBy(quote.reservation.numGuests === 0 ? 1 : quote.reservation.numGuests).toDecimalPlaces(2).toNumber();
  const [remainingReservationBalance, setRemainingReservationBalance] = useState<number>(0.0);

  const [updateRequest, setUpdateRequest] = useState<ReservationCustomer>();
  const updateResponse = useUpdateReservationCustomers(updateRequest);

  const [emailCustomerRequest, setEmailCustomerRequest] = useState<FetchRequest>();
  const emailCustomerResponse = useFetch(emailCustomerRequest);

  const [formErrors, setFormErrors] = useState({ join: false, name: false, email: false, index: -1 });

  function emailPayLinks() {
    const customerIds: number[] = [];
    reservationCustomers.forEach((c => customerIds.push(c.customerId)));

    setEmailCustomerRequest({
      url: `${Constants.apiUrl}/api/v1.0/reservation/customers/emails`,
      method: 'POST',
      body: {
        reservationId: quote.reservation.reservationId,
        // customerIds: customerIds
      }
    });
  }

  const addGuest = (guest: any) => {
    if (reservationGuests.find(g => g.name == undefined) == undefined) return;

    const nameExp = /^(?=\S)[a-zA-Z]{2,}(?:[a-zA-Z]| (?! ))*(?! )$/i;
    const emailExp = /(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9]))\.){3}(?:(2(5[0-5]|[0-4][0-9])|1[0-9][0-9]|[1-9]?[0-9])|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/;

    if (guest.name !== undefined)
      guest.name = guest.name.trim();
    if (guest.email !== undefined)
      guest.email = guest.email.trim();

    const namePass = nameExp.test(guest.name) && guest.name !== undefined;
    const emailPass = emailExp.test(guest.email);

    const errors = { name: !namePass, email: !emailPass, join: true, index: guest.index };
    setFormErrors(errors);

    if (errors.name || errors.email) return;

    const category = quote.reservation.paymentCategories ? quote.reservation.paymentCategories.find(c => c.paymentAllocationCategoryId === guest.categoryId) : undefined;

    const name: string[] = guest.name.split(" ");
    const first = name.shift();
    const last = name.join(" ");

    setUpdateRequest({
      reservationId: quote.reservationId ? quote.reservationId : 0,
      customerId: 0,
      cancelled: false,
      paymentAllocationCategoryId: category ? category.paymentAllocationCategoryId : undefined,
      customer: {
        customerId: 0,
        companyId: companyId as number,
        firstName: first as string,
        lastName: last,
        emailAddress: `${guest.email}`
      }
    });
  }

  useEffect(() => {
    setQuote(props.quote);
  }, [props.quote]);

  useEffect(() => {
    const payments = quote.reservation.payments;
    const guests: ReservationGuest[] = [];
    const paymentCategories = quote.reservation.paymentCategories === undefined ? [] : quote.reservation.paymentCategories;

    const filteredCustomers = reservationCustomers.filter(rc => !rc.cancelled);
    const totalAllocationCost = PaymentAllocationCategory.getTotalAllocationsCost(paymentCategories, itinerary, props.quote.reservation.numGuests - props.quote.reservation.reservationCustomers.filter(c => c.cancelled).length);

    for (let index = 0; index < reservationCustomers.length; index++) {
      const reservationCustomer = reservationCustomers[index];
      const customerPayments = payments ? payments.filter(p => p.customerId === reservationCustomer.customerId) : [];
      const okPayments = customerPayments.filter(p => p.status === null || p.status == "Complete" || p.status == "Pending" || p.paymentTypeId === 20);
      const cancelledPayments = customerPayments.filter(p => p.status === "Canceled");

      // let paymentsAmount = customerPayments !== undefined && customerPayments.length > 0 ? okPayments.reduce(function (acc, obj) { return acc + obj.paymentAmount; }, 0) : 0.0;
      // const tipAmount = customerPayments !== undefined && customerPayments.length > 0 ? okPayments.reduce(function (acc, obj) { return acc + obj.tipAmount; }, 0) : 0.0;
      // let paymentsAmount = okPayments.reduce(function (acc, obj) { return acc + obj.paymentAmount; }, 0) - cancelledPayments.reduce(function (acc, obj) { return acc + obj.paymentAmount; }, 0);
      let paymentsAmount = okPayments.reduce(function (acc, obj) { return acc + obj.paymentAmount; }, 0);
      const tipAmount = okPayments.reduce(function (acc, obj) { return acc + obj.tipAmount; }, 0);
      paymentsAmount -= tipAmount;

      let allocationCost = 0.0;
      if (!!reservationCustomer.paymentAllocationCategory && reservationCustomer.paymentAllocationCategory.allocationLines !== undefined) {
        if (reservationCustomer.paymentAllocationCategory.categoryName === "Even Split") {
          // get even split cost

          // temp
          allocationCost = evenPerPersonPrice;

        } else {
          allocationCost = PaymentAllocationCategory.getCost(reservationCustomer.paymentAllocationCategory, itinerary, props.quote.reservation.numGuests - props.quote.reservation.reservationCustomers.filter(c => c.cancelled).length);
        }
      }

      guests.push({
        reservationId: reservationCustomer.reservationId,
        customerId: reservationCustomer.customerId,
        cancelled: reservationCustomer.cancelled,
        name: `${reservationCustomer.customer.firstName} ${reservationCustomer.customer.lastName}`,
        email: `${reservationCustomer.customer.emailAddress}`,
        price: !!reservationCustomer.paymentAllocationCategory ? allocationCost : (filteredCustomers.length > 1 ? evenPerPersonPrice : totalSell), // how much to pay from allocation category
        balanceDue: !!reservationCustomer.paymentAllocationCategory ? (allocationCost - paymentsAmount) : (filteredCustomers.length > 1 ? evenPerPersonPrice - paymentsAmount : totalSell - paymentsAmount), // this will come from the reservation guest info later
        payments: customerPayments,
        paymentAllocationCategoryId: reservationCustomer.paymentAllocationCategoryId,
        index,
        paymentsAmount: paymentsAmount,
        tipAmount: tipAmount
      });
    }

    if (paymentCategories.length > 0) {
      const count = filteredCustomers.length;
      const sortedCats = paymentCategories.sort((a, b) => {
        if (a.categoryName === "Even Split" && b.categoryName !== "Even Split") return -1;
        if (a.categoryName !== "Even Split" && b.categoryName === "Even Split") return 1;
        return 0;
      });

      for (let index = 0; index < quote.reservation.numGuests - count; index++) {
        let category: PaymentAllocationCategory | undefined;

        // console.log("paymentAllocations", paymentAllocations);
        sortedCats.forEach(cat => {
          const count = PaymentAllocationCategory.getGuestCount(guests, cat);
          if (cat.allocationLines !== undefined && count < cat.allocationLines && cat.categoryName !== "-") {
            category = cat;
            return;
          }
        });

        let allocationCost = 0.0;

        if (!!category && category.allocationLines !== undefined) {
          if (category.categoryName === "Even Split") {
            // // get even split cost
            allocationCost = evenPerPersonPrice;
          } else {
            allocationCost = PaymentAllocationCategory.getCost(category, itinerary, props.quote.reservation.numGuests - props.quote.reservation.reservationCustomers.filter(c => c.cancelled).length);
          }
        }

        const guest = {
          reservationId: 0,
          customerId: 0,
          cancelled: false,
          price: allocationCost,
          balanceDue: allocationCost,
          payments: [],
          index: -1,
          customer: undefined,
          paymentAllocationCategoryId: category !== undefined ? category.paymentAllocationCategoryId : undefined,
          paymentsAmount: 0.0,
          tipAmount: 0.0
        };

        guests.push(guest);
      }
    }

    // //reservationGuest.payments.reduce(function (acc, obj) { return acc + obj.paymentAmount; }, 0).toFixed(2)
    let totalPayments = 0.0;
    guests.forEach((guest: ReservationGuest) => totalPayments += guest.payments.filter(p => p.status === null || p.status == "Complete" || p.status == "Pending" || p.paymentTypeId === 20).reduce(function (acc, obj) { return acc + obj.paymentAmount; }, 0))
    guests.forEach((guest: ReservationGuest) => totalPayments -= guest.payments.filter(p => p.status === null || p.status == "Complete" || p.status == "Pending" || p.paymentTypeId === 20).reduce(function (acc, obj) { return acc + obj.tipAmount; }, 0))
    setRemainingReservationBalance(totalSell - totalPayments);
    setReservationGuests([...guests]);

  }, [quote]);

  useEffect(() => {
    if (updateResponse.data == undefined) return;

    // console.log("customer updated", updateResponse.data);
    onReservationCustomerAdded(updateResponse.data);
  }, [updateResponse.data]);

  useEffect(() => {
    if (!emailCustomerResponse.data) {
      return;
    }

    toast.success(emailCustomerResponse.data.message);
  }, [emailCustomerResponse.data]);

  useEffect(() => {
    if (!emailCustomerResponse.error) {
      return;
    }

  }, [emailCustomerResponse.error]);

  const [createIndividualRequest, setCreateIndividualRequest] = useState<CreateIndividualCategoryRequest>();
  const createIndividualResponse = useCreateIndividualCategory(createIndividualRequest);

  function handleIndividualPayments() {
    setCreateIndividualRequest({ reservationId: quote.reservationId as number });
  }

  useEffect(() => {
    if (!createIndividualResponse.data) return;

    const cat: PaymentAllocationCategory = createIndividualResponse.data.category;
    quote.reservation.paymentCategories = [cat];
    quote.reservation.reservationCustomers.forEach((resCust: ReservationCustomer) => {
      resCust.paymentAllocationCategory = cat;
      resCust.paymentAllocationCategoryId = cat.paymentAllocationCategoryId;
    });
    props.handleUseIndividualPayments(quote);
  }, [createIndividualResponse.data]);

  return (
    <React.Fragment>
      <div className="itinerary-font mt-5 ml-1 mr-1">
        {/* Totals */}
        <Accordion defaultActiveKey="1">
          <div className="w-100 d-flex flex-row justify-content-end">
            <Col
              xs={12}
              md={4}
              className="d-flex flex-row justify-content-between"
              style={{ paddingLeft: "0px", paddingRight: "0px", borderBottom: "3px solid green" }}
            >
              {/* Header */}
              <h4 className="green-text bold-text">
                Totals
              </h4>
              {/* TOGGLE */}
              {/* <Accordion.Toggle
                className="collapse-button itinerary-font bold-text"
                as={Button}
                variant="link"
                eventKey="1"
                disabled
              >
                Collapse <span style={{ fontWeight: "bold" }}>+</span>
              </Accordion.Toggle> */}
            </Col>
          </div>

          <Accordion.Collapse eventKey="1" >
            <div className="w-100 d-flex flex-row justify-content-end mt-2">
              <Col xs={12} md={3} style={{ borderBottom: "2px solid green" }}>
                {/* Discount Applied */}
                {props.allowPromo && promoCodeName !== undefined && quote.reservation.promo !== undefined && quote.reservation.promo.discount !== 0 && (
                <Col className="d-flex flex-row justify-content-end">
                  <Col xs={12} className="d-flex flex-row justify-content-between">
                    <label className="green-text bold-text">
                      Promo Applied:
                    </label>
                    <label className="green-text bold-text">{`${promoCodeName} -$${discountsApplied.toFixed(2)}`}</label>
                  </Col>
                </Col>
                )}

                {/* Package price */}
                <Col className="d-flex flex-row justify-content-end">
                  <Col xs={12} className="d-flex flex-row justify-content-between">
                    <label className="green-text bold-text">
                      Total Package Price:
                    </label>
                    <label className="green-text bold-text">{`$${(totalSell + discountsApplied).toFixed(2)}`}</label>
                  </Col>
                </Col>

                {/* Tax */}
                <Col className="d-flex flex-row justify-content-end">
                  {startWidget.showTaxesTotal && (
                    <Col xs={12} className="d-flex flex-row justify-content-between">
                      <label className="green-text bold-text">Tax:</label>
                      <label className="green-text bold-text">{`$${tax.toFixed(2)}`}</label>
                    </Col>
                  )}
                </Col>

                {/* Resort Fee */}
                <Col className="d-flex flex-row justify-content-end">
                  {startWidget.showResortFeeTotal && (
                    <Col xs={12} className="d-flex flex-row justify-content-between">
                      <label className="green-text bold-text">Resort Fee:</label>
                      <label className="green-text bold-text">{`$${resortFees.toFixed(2)}`}</label>
                    </Col>
                  )}
                </Col>

                {/* Cleaning Fee */}
                <Col className="d-flex flex-row justify-content-end">
                  {startWidget.showCleaningFeeTotal && (
                    <Col xs={12} className="d-flex flex-row justify-content-between">
                      <label className="green-text bold-text">Cleaning Fee:</label>
                      <label className="green-text bold-text">{`$${cleaningFees.toFixed(2)}`}</label>
                    </Col>
                  )}
                </Col>
              </Col>
            </div>
          </Accordion.Collapse>

          <div>
            {/* Grand Total */}
            <Col className="d-flex flex-row justify-content-end mt-2">
              {startWidget.showGrandTotal && (
                <Col xs={12} md={3} className="d-flex flex-row justify-content-between">
                  <label className="green-text font-weight-bold">Grand Total:</label>
                  <label className="green-text bold-text">{`$${totalSell.toFixed(2)}`}</label>
                </Col>
              )}
            </Col>

            {/* Per Person */}
            <Col className="d-flex flex-row justify-content-end">
              {startWidget.showPerPersonPricing && !quote.reservation.reservationCustomers.some(rc => rc.paymentAllocationCategory != null) && (
                <Col xs={12} md={3} className="d-flex flex-row justify-content-between">
                  <label className="green-text font-weight-bold">Per Person:</label>
                  <label className="green-text bold-text">{`$${resPerPersonPrice.toFixed(2)}`}</label>
                </Col>
              )}
            </Col>

            <Col className="d-flex flex-row justify-content-end">
              <Col xs={12} md={3} className="d-flex flex-row justify-content-between">
                <label className="green-text font-weight-bold">Remaining Balance:</label>
                <label className="green-text bold-text">{`$${(remainingReservationBalance.toFixed(2))}`}</label>
              </Col>
            </Col>
          </div>
        </Accordion>

        {/* Make Payment Section */}
        <Col
          style={{
            marginTop: "40px",
          }}
        >
          {/* Make Payment Button */}
          {!hasAllocations && (
            <Col className="d-flex flex-row mb-2">
              <Col
                className="d-flex justify-content-end"
                style={{ marginTop: "10px" }}
              >
                <Button
                  className="green-button"
                  style={{ minWidth: "198px" }}
                  onClick={() => setShowModal("make-payment")}
                  disabled={props.isQuoteExpired}
                >
                  Make Payment
                </Button>
              </Col>
            </Col>
          )}

          {!hasAllocations && (
            <div className="w-100 d-flex flex-row justify-content-end">
              <Button
                disabled={props.isQuoteExpired}
                className="green-button"
                onClick={handleIndividualPayments}
              >
                {createIndividualResponse.isLoading ? (
                  <span><Spinner
                    as="span"
                    animation="border"
                    size="sm"
                    role="status"
                    aria-hidden="true"
                  /> Loading...</span>
                ) : (
                    <span>
                      Use Individual Payments
                    </span>
                  )}
              </Button>
            </div>
          )}

          <Accordion activeKey={hasAllocations || (quote.reservation.payments !== undefined && quote.reservation.payments.length > 0) ? "0" : undefined}>
            <Accordion.Collapse eventKey="0" className="mt-4">
              <>
                <Col
                  className="d-flex flex-row justify-content-between"
                  style={{ paddingLeft: "0px", paddingRight: "0px" }}
                >
                  {/* Header */}
                  <h4 className="green-text bold-text">
                    Payment Categories and Accounting
                  </h4>
                </Col>

                <div>
                  <Col
                    className="md-none d-md-block"
                    style={{ paddingRight: "0px", paddingLeft: "0px" }}
                  >
                    <div>
                      {/* Divider */}
                      <Col
                        className="d-flex flex-row"
                        style={{ paddingLeft: "0px", paddingRight: "0px" }}
                      >
                        <Col
                          className="d-flex flex-row"
                          style={{
                            borderBottom: "3px solid green",
                            paddingRight: "0px",
                            paddingLeft: "0px",
                          }}
                        />
                      </Col>

                      {/* Individual payment header */}
                      {viewPortBreakPoint >= ViewPort.md && (
                        <div
                          className="m-0 p-0 pt-2 w-100 d-flex flex-row justify-content-between"
                          style={{ marginTop: "10px", color: style.fontColor }}
                        >
                          <Col
                            xs={6}
                            className="m-0 p-0 d-flex flex-row justify-content-between payment-row-left payment-row-right"
                          >
                            <Col xs={4} className="itinerary-label-text m-0 p-0 font-weight-bold">
                              Name of Guest
                            </Col>
                            <Col xs={4} className="itinerary-label-text font-weight-bold">
                              Email Address
                            </Col>
                            <Col xs={4} className="itinerary-label-text text-center font-weight-bold">
                              Category
                            </Col>
                          </Col>

                          <Col></Col>

                          <Col
                            xs={3}
                            className="d-flex flex-row justify-content-between payment-row-right"
                          >
                            <Col
                              className="d-flex justify-content-start itinerary-label-text totals-row"
                              style={{ paddingLeft: "0px", marginLeft: "21px" }}
                            >
                              Balance
                            </Col>
                            <Col className="d-flex justify-content-center itinerary-label-text totals-row">
                              Paid
                            </Col>
                            <Col
                              className="d-flex justify-content-end itinerary-label-text totals-row"
                              style={{ paddingRight: "0px" }}
                            >
                              Price
                            </Col>
                          </Col>
                        </div>
                      )}

                      {/* Guest Info */}
                      {reservationGuests.map((reservationGuest: ReservationGuest, index: number) => (
                        <div className="mt-1">
                          {!reservationGuest.cancelled && (
                            <GuestInfo
                              key={reservationGuest.toString()}
                              index={index}
                              reservationGuest={reservationGuest}
                              remainingReservationBalance={remainingReservationBalance}
                              onJoinClicked={addGuest}
                              onPayClicked={(index: number) => {
                                onPayClicked(reservationCustomers[reservationGuests[index].index])
                              }}
                              isLoading={updateResponse.isLoading}
                              errors={formErrors}
                              paymentCategories={quote.reservation.paymentCategories}
                              itinerary={itinerary}
                              reservationGuests={reservationGuests}
                              isQuoteExpired={props.isQuoteExpired}
                            />
                          )}
                        </div>
                      ))}

                      {/* Payment Emails */}
                      <Row
                        className="d-flex flex-row"
                        style={{ paddingRight: "0px" }}
                      >
                        <Col
                          xs={9}
                          className="d-flex flex-row justify-content-start"
                          style={{ marginTop: "15px", paddingLeft: "0px" }}
                        >
                          <p className="itinerary-info">
                            {`Do you need custom itineraries with single & double occupancy, specific schedules, or golf only costs? Call ${brand?.phoneNumber} we can set it up for you.`}
                          </p>
                        </Col>
                        <Col
                          className="d-flex flex-column justify-content-center"
                          style={{ paddingRight: "0px" }}
                        >
                          <Button
                            disabled={props.isQuoteExpired}
                            className="all-payment-email-button"
                            style={{
                              marginLeft: "0px",
                              borderRadius: "0.25rem"
                            }}
                            onClick={emailPayLinks}
                          >
                            <Row className="justify-content-center align-items-center">
                              {(emailCustomerResponse.isLoading) && (
                                <Spinner
                                  className="mr-0"
                                  as="span"
                                  animation="border"
                                  size="sm"
                                  role="status"
                                  aria-hidden="true"
                                />
                              )}
                              {(emailCustomerResponse.isLoading) ? "Emailing..." : "Send Payment Emails"}
                            </Row>
                          </Button>
                        </Col>
                      </Row>

                      {/* Canceled Guests */}
                      {reservationGuests.filter((rc: ReservationGuest) => rc.cancelled).length > 0 && (
                        <>
                          <Col xs={8} className="d-flex flex-row">
                            <h6 className="itinerary-label-text">
                              Canceled Guests
                            </h6>
                          </Col>
                          <Col
                            className="d-flex flex-column justify-content-between payment-row-left"
                            style={{ marginTop: "10px" }}
                          >
                            {reservationGuests.map((reservationGuest: ReservationGuest, index: number) => (
                              <>
                                {reservationGuest.cancelled && (
                                  <GuestInfo
                                    key={reservationGuest.toString()}
                                    index={index}
                                    reservationGuest={reservationGuest}
                                    remainingReservationBalance={remainingReservationBalance}
                                    onJoinClicked={addGuest}
                                    onPayClicked={(index: number) => {
                                      onPayClicked(reservationCustomers[reservationGuests[index].index])
                                    }}
                                    isLoading={updateResponse.isLoading}
                                    errors={formErrors}
                                    paymentCategories={quote.reservation.paymentCategories}
                                    itinerary={itinerary}
                                    reservationGuests={reservationGuests}
                                    isQuoteExpired={props.isQuoteExpired}
                                  />
                                )}
                              </>
                            ))}
                          </Col>
                        </>
                      )}
                    </div>
                  </Col>
                </div>
              </>
            </Accordion.Collapse>
          </Accordion>
        </Col>
      </div>
    </React.Fragment>
  );
}

export default Total;